$(".responsive-filter-cat.inside li a").each(function () {
    var paneltitle = $(".panel-title").html();
    if ($(this).hasClass("active")) {
        $(".panel-title").html(
            paneltitle + '<i class="bi bi-circle mx-2"></i>' + $(this).text()
        );
    }
});
